/* Le Club des Petits Bonheurs — comportements de la landing page
   (choix de formule depuis les cartes tarifs, barre d'achat collante,
   lecture de la vidéo, libellé du bouton d'achat). */
(function () {
  'use strict';
  if (window.__clubLandingInit) return;
  window.__clubLandingInit = true;

  document.documentElement.classList.add('template-club');
  if (document.body) document.body.classList.add('template-club');

  var buybox = document.querySelector('[data-club-buybox]');
  var config = buybox ? buybox.dataset : {};

  function getProductForm() {
    return document.querySelector('product-form form[data-type="add-to-cart-form"]') || document.querySelector('form[action*="/cart/add"]');
  }
  function getSubmit() {
    var form = getProductForm();
    return form ? form.querySelector('.product-form__submit, [name="add"]') : null;
  }
  function getPlanRadios() {
    return Array.prototype.slice.call(document.querySelectorAll('.shopify_subscriptions_app_block input[type="radio"][data-radio-type]'));
  }

  /* --- Libellé du bouton d'achat ---------------------------------------- */
  function applyCtaLabel() {
    var submit = getSubmit();
    if (!submit || !config.ctaLabel) return;
    var span = submit.querySelector('span');
    if (span && !submit.disabled && span.textContent.trim() !== config.ctaLabel) span.textContent = config.ctaLabel;
  }

  /* --- Sélection d'une formule ------------------------------------------ */
  function selectPlan(kind) {
    var radios = getPlanRadios();
    if (!radios.length) return false;
    var target = radios.filter(function (r) {
      return kind === 'subscription' ? r.dataset.radioType === 'selling_plan' : r.dataset.radioType === 'one_time_purchase';
    })[0];
    if (!target) return false;
    if (!target.checked) {
      target.click();
      target.dispatchEvent(new Event('change', { bubbles: true }));
    }
    return true;
  }

  function pulseSubmit() {
    var submit = getSubmit();
    if (!submit) return;
    submit.classList.remove('club-pulse');
    void submit.offsetWidth; // relance l'animation
    submit.classList.add('club-pulse');
  }

  function scrollToBuybox(focusSubmit) {
    var anchor = document.getElementById('club-buybox') || getProductForm();
    if (!anchor) return;
    var header = document.querySelector('.shopify-section-header-sticky, .section-header');
    var offset = header ? header.getBoundingClientRect().height + 12 : 12;
    var top = anchor.getBoundingClientRect().top + window.pageYOffset - offset;
    window.scrollTo({ top: top, behavior: 'smooth' });
    if (focusSubmit) {
      window.setTimeout(function () {
        pulseSubmit();
        var submit = getSubmit();
        if (submit) submit.focus({ preventScroll: true });
      }, 600);
    }
  }

  document.addEventListener('click', function (event) {
    var planBtn = event.target.closest('[data-club-plan]');
    if (planBtn) {
      event.preventDefault();
      selectPlan(planBtn.dataset.clubPlan);
      scrollToBuybox(true);
      return;
    }
    var scrollBtn = event.target.closest('[data-club-scroll]');
    if (scrollBtn) {
      event.preventDefault();
      scrollToBuybox(true);
    }
  });

  /* --- Formule sélectionnée par défaut ---------------------------------- */
  function applyDefaultPlan() {
    if (config.defaultPlan !== 'subscription') return;
    var attempts = 0;
    var timer = window.setInterval(function () {
      attempts += 1;
      if (selectPlan('subscription') || attempts > 20) window.clearInterval(timer);
    }, 250);
  }

  /* --- Vidéo (reel) ------------------------------------------------------ */
  document.querySelectorAll('[data-club-video]').forEach(function (wrapper) {
    var video = wrapper.querySelector('video');
    var play = wrapper.querySelector('.club-video__play');
    if (!video || !play) return;
    play.addEventListener('click', function () {
      wrapper.classList.add('is-playing');
      video.muted = false;
      video.setAttribute('controls', 'controls');
      var promise = video.play();
      if (promise && promise.catch) promise.catch(function () { video.muted = true; video.play(); });
    });
    video.addEventListener('ended', function () {
      wrapper.classList.remove('is-playing');
      video.currentTime = 0;
    });
  });

  /* --- Vidéos en boucle (voyage de l'enveloppe) ---------------------------- */
  function initLoops() {
    var loops = document.querySelectorAll('video[data-club-loop]');
    if (!loops.length || !('IntersectionObserver' in window)) return;
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var saveData = navigator.connection && navigator.connection.saveData;
    if (reduceMotion || saveData) return; // on garde simplement l'image de couverture
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var video = entry.target;
        if (entry.isIntersecting) {
          if (!video.getAttribute('src')) {
            video.src = video.dataset.src;
            video.load();
          }
          var promise = video.play();
          if (promise && promise.catch) promise.catch(function () {});
        } else if (!video.paused) {
          video.pause();
        }
      });
    }, { rootMargin: '200px 0px', threshold: 0 });
    loops.forEach(function (video) { observer.observe(video); });
  }

  /* --- Barre d'achat collante (mobile) ----------------------------------- */
  function initSticky() {
    var bar = document.querySelector('[data-club-sticky]');
    var form = getProductForm();
    if (!bar || !form || !('IntersectionObserver' in window)) return;
    var observer = new IntersectionObserver(function (entries) {
      var visible = entries[0].isIntersecting;
      bar.classList.toggle('is-visible', !visible);
      document.body.classList.toggle('club-sticky-visible', !visible);
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0 });
    observer.observe(form);
  }

  function init() {
    if (document.body) document.body.classList.add('template-club');
    applyCtaLabel();
    applyDefaultPlan();
    initSticky();
    initLoops();
    // Le widget d'abonnement recharge parfois son contenu : on ré-applique le libellé.
    var submitObserverTarget = getProductForm();
    if (submitObserverTarget && 'MutationObserver' in window) {
      new MutationObserver(function () { applyCtaLabel(); }).observe(submitObserverTarget, { childList: true, subtree: true, characterData: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
